import { render, staticRenderFns } from "./raporparametre.vue?vue&type=template&id=56d166c8&"
import script from "./raporparametre.vue?vue&type=script&lang=js&"
export * from "./raporparametre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports